/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FlagAIcon20Light = forwardRef('FlagAIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 19.5a.5.5 0 0 0 1 0V14h13.5a.5.5 0 0 0 .41-.787L14.61 8.5l3.3-4.713A.5.5 0 0 0 17.5 3h-13A1.5 1.5 0 0 0 3 4.5v15ZM4.5 4a.5.5 0 0 0-.5.5V13h12.54l-2.95-4.213a.5.5 0 0 1 0-.574L16.54 4H4.5Z" })));
});
